let tokenName = "APP_TOKEN";

export function createToken(data) {
  localStorage.setItem(tokenName, data);
}

export function setUser(data) {
  localStorage.setItem('data_user', JSON.stringify(data));
}

export function getUser() {
  let data = localStorage.getItem('data_user');
  let response = null;
  if (data) {
    response = JSON.parse(data);
  }
  return response;
}

export function getToken() {
  let data = localStorage.getItem('APP_TOKEN');
  return data;
}

export function logout() {
  localStorage.removeItem(tokenName);
  localStorage.removeItem('data_user');
}